import { render } from "./brandRelatedFeatures.vue?vue&type=template&id=537a24ca"
import script from "./brandRelatedFeatures.vue?vue&type=script&lang=js"
export * from "./brandRelatedFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__